import { render } from "./FooterBottom.vue?vue&type=template&id=15ed26f6&scoped=true"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"

import "./FooterBottom.vue?vue&type=style&index=0&id=15ed26f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ed26f6"]])

export default __exports__